import { Add } from "@mui/icons-material";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import { Badge, Box, Button, Divider, Typography } from "@mui/material";
import React from "react";
import FormDrawer from "components/Shared/FormDrawer";
import { toast } from "react-toastify";
import ServiceList from "./ServiceList";
import ServiceForm from "./ServiceForm";
import { useUpdateBranchMutation } from "store/services/branchApi";
import LoadingWrapper from "components/Shared/LoadingWrapper";
import { useAuth } from "hooks";

const ServicesTab = ({ branchDetail }) => {
  const [showServiceForm, setShowServiceForm] = React.useState(false);

  const [updateService, { isLoading: updatingService }] =
    useUpdateBranchMutation();

  const { isAdmin } = useAuth();

  const handleUpdateService = async (data) => {
    try {
      await updateService({
        ...data,
        _id: branchDetail?._id,
      }).unwrap();
      toast.success("Service added successfully");
      setShowServiceForm(false);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't add Service!"
      );
    }
  };

  const handleCancelService = () => {
    setShowServiceForm(false);
  };

  return (
    <LoadingWrapper loading={updatingService}>
      <Box
        display="flex"
        alignItems="end"
        justifyContent="space-between"
        padding={2}
      >
        <Box display="inline-flex" alignItems="center" gap={1.5}>
          <Badge
            badgeContent={branchDetail?.service?.length || 0}
            color="primary"
          >
            <SupportAgentIcon style={{ color: "gray" }} />
          </Badge>
          <Typography style={{ fontWeight: 500 }}>Services</Typography>
        </Box>

        {isAdmin && (
          <Button
            startIcon={<Add />}
            variant="outlined"
            onClick={() => setShowServiceForm(true)}
          >
            Service
          </Button>
        )}
      </Box>

      <Divider />

      <ServiceList
        services={branchDetail?.service || []}
        branchDetail={branchDetail}
        isBusy={updatingService}
      />

      <FormDrawer
        title="Add Service"
        open={showServiceForm}
        onClose={handleCancelService}
      >
        <ServiceForm
          branchDetail={branchDetail}
          isBusy={updatingService}
          onSubmit={(data) => handleUpdateService(data)}
          onCancel={handleCancelService}
        />
      </FormDrawer>
    </LoadingWrapper>
  );
};

export default ServicesTab;
